var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-container"},[_c(_vm.currentView,_vm._b({tag:"component",on:{"change-view":_vm.changeView,"go-back-view":_vm.goBackView,"go-home-view":_vm.goHomeView}},'component',_vm.componentProps,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }